import React from "react";
import HomeNavBar from "../Components/HomeNavBar/HomeNavBar";
import Footer from "../Components/Footer/Footer";
import HydroponicFarming from "../Components/HydroponicFarming/HydroponicFarming";


const HydroponicFarmingPage = () => {
      return (
            <div>
                  <HomeNavBar/>
                  <HydroponicFarming />
                  <Footer />
            </div>
      );
};

export default HydroponicFarmingPage;